import { useParams } from "react-router";
import useOrder from "./use_order";
import { get_image_url } from "../api";
import { getGroupName } from "../orders/orders";
function Order() {
  let { id } = useParams();
  const order = useOrder(id);
  return (
    <div className="m-4 max-w-7xl mx-auto">
      {order.isSuccess && (
        <div className="lg:flex lg:justify-between w-100">
          <OrderInformation order={order.order} />
          <Checkout checkout={order.checkout} />
        </div>
      )}
    </div>
  );
}
function Checkout({ checkout, groups }) {
  return (
    <div>
      <div className="flex flex-col gap-4 max-lg:pt-8">
        {checkout.items.map((item) => (
          <div className="flex gap-4">
            <img
              className="w-24 h-24 object-cover rounded"
              src={get_image_url(item.item_image)}
              alt="..."
            />
            <div className="text-lg">
              <div className="flex">
                <div title="Item id">[{item.item.item_id}]</div>
                <div className="px-2">{item.item.item_name}</div>
                <div>{getGroupName(item.item.item_group_id)}</div>
              </div>
              <div>{item.item.item_description}</div>
              <div>
                {"$"}
                {(item.item.item_price / 100).toFixed(2)} x ({item.item_count})
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="text-lg pt-8">
        <div className="flex justify-between">
          <div>Sub Total:</div>
          <div>
            {"$"}
            {(checkout.sub_total / 100).toFixed(2)}
          </div>
        </div>
        <div className="w-full border-t border-gray-300" />

        <div className="flex justify-between">
          <div>Discount: </div>
          <div>
            {"$"}
            {(checkout.discount / 100).toFixed(2)}
          </div>
        </div>
        <div className="w-full border-t border-gray-300" />
        <div className="flex justify-between">
          <div>New Total: </div>
          <div>
            {"$"}
            {(checkout.new_total / 100).toFixed(2)}
          </div>
        </div>
        <div className="w-full border-t border-gray-300" />
        <div className="flex justify-between">
          <div>Shipping: </div>
          <div>
            {"$"}
            {(checkout.shipping / 100).toFixed(2)}
          </div>
        </div>
        <div className="w-full border-t border-gray-300" />
        <div className="flex justify-between">
          <div>Tax: </div>
          <div>
            {"$"}
            {(checkout.tax / 100).toFixed(2)}
          </div>
        </div>
        <div className="w-full border-t border-gray-300" />
        <div className="flex justify-between">
          <div>Total: </div>
          <div>
            {"$"}
            {(checkout.total / 100).toFixed(2)}
          </div>
        </div>
        <div className="w-full border-t border-gray-300" />
        <div className="flex justify-between">
          <div>Promotion Type: </div>
          <div>
            <DiscountTypeToName type={checkout.discount_type} />
          </div>
        </div>
        <div className="w-full border-t border-gray-300" />
        <div className="flex justify-between">
          <div>Message:</div>
          <div>{checkout.message}</div>
        </div>
      </div>
    </div>
  );
}
function DiscountTypeToName({ type }) {
  return (
    <>
      {type === 1 && <>Percent</>}
      {type === 2 && <>Flat Rate</>}
      {type === 3 && <>Tiered</>}
      {type === 4 && <>Athelete / Fundraiser</>}
    </>
  );
}
function OrderInformation({ order }) {
  return (
    <div className="text-lg flex flex-col gap-1">
      <div className="font-semibold">
        {order.first_name} {order.last_name}
      </div>
      <div className="w-full border-t border-gray-300" />
      <div>{order.address_1}</div>
      <div>{order.address_2}</div>
      <div>
        {order.city} {order.state}, {order.zip_code}
      </div>
      <div className="w-full border-t border-gray-300" />
      <div>
        {order.phone_number.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2 - $3")}
      </div>
      <div>{order.email} </div>
      <div className="w-full border-t border-gray-300" />

      <div title="this is when they first put items in a cart">
        Order Created: {new Date(order.created_date).toUTCString()}
      </div>
      <div title="this is when they first click submit">
        Order Placed:{" "}
        {order.info_created_date
          ? new Date(order.info_created_date).toUTCString()
          : "NOT PLACED"}
      </div>
      <div title="this is when payment is confirmed">
        Order Paid:{" "}
        {order.paid_date ? new Date(order.paid_date).toUTCString() : "NOT PAID"}
      </div>
      <div title="this is when the order is complete">
        Order Shipped:{" "}
        {order.ship_date
          ? new Date(order.ship_date).toUTCString()
          : "NOT SHIPPED"}
      </div>
      <div className="w-full border-t border-gray-300" />
      <div>Send cups: [{order.send_cups ? "True" : "False"}] </div>
      <div>Promotion Code: ({order.discount_code}) </div>
    </div>
  );
}

export default Order;
